import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubmitdataService } from "src/app/services/submitdata/submitdata.service";
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { GisService } from 'src/app/services/gis/gis.service';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-approvalinfo',
  templateUrl: './approvalinfo.component.html',
  styleUrls: ['./approvalinfo.component.css']
})
export class ApprovalinfoComponent implements OnInit {
  @Input() stateuuid;
  @Input() ay;
  @Input() subtimeperiod;
  @Input() statename;
  @Input() type;
  @Input() weightdata;
  @Input() isverified;
  @Input() stateDistrict;

  activeSpinner : boolean;
  indicatorTableData = [];
  editreportTableData = [];
  indicatorsdata;
  userdetails = {};
  validation_agency;
  is_validation_agency;
  dgcvalidation: any;
  reportTableData: any = [];

  constructor(
    private submitdataservice : SubmitdataService,
    public activeModal: NgbActiveModal,
    private constants : ConstantsModule,
    public utils: UtilsModule,
    private gisService : GisService,
    private logsrv : AuthloginService,
    private toastr : ToastrService
  ) {
   }

  ngOnInit() {
    this.userdetails = this.logsrv.checkloginstatus();
    this.dgcvalidation = this.constants.USER_TYPES['DISTRICT_VALIDATE_MEMBER'];
    if(this.dgcvalidation == this.userdetails['roles'][0]){
      this.dgcvalidation = true;
    } else {
      this.dgcvalidation = false;
    }
    if(this.type == 'admin-weightage'){
      this.indicatorsdata = this.weightdata;
      this.getIndicatorsHeirarchy();
    } else
     this.getDataforEditreport()
  }

  getIndicatorRanking(){
    this.activeSpinner = true;
    let postdata = { 
      "view":this.constants.VIEWS['admin'],
      "cType":this.constants.LOCATION_CONSTANT['DISTRICT'],
      "pType":this.constants.LOCATION_CONSTANT['BASIN'],
      "ay":this.ay,
      "lu":this.stateuuid,
      "reportType":this.isverified ? true : false,
      'userType' : this.userdetails['roles'][0]
    }
    this.gisService.getIndicatorRanking(postdata).subscribe(data =>{
      this.indicatorsdata = data;
      this.getIndicatorsHeirarchy();
     
    });
  }
  getDataforEditreport(){
    this.activeSpinner = true;
    let postdata= {
      "view": "admin",
      "cType": this.constants.LOCATION_CONSTANT['DISTRICT'],
      "pType":this.constants.LOCATION_CONSTANT['STATE'],
      "ay":this.ay,
      // "lu" : this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'],
      "lu" : this.stateuuid,
      "userType": this.userdetails['roles'][0],
      "reportType":this.isverified ? true : false,
      "subTp" : this.subtimeperiod,
      "isPreviousYearDataReq": false,
    }
    this.gisService.getIndicatorRanking(postdata).subscribe(data => {
      this.activeSpinner = false;
      this.editreportTableData = data;
      let tempobj1;
      let tempobj2;
      this.editreportTableData.forEach(report => {        
        if(report['name'] != "Date Of The Meeting"){
          if(report['uuid'] == "aff6273a-fd36-458a-9b99-5758f5278edd"){
            report['sno'] = "2.10"
          }
          if(report['sno'] == "2.10"){            
            tempobj1 = report;            
          } else if(report['sno'] == "2.11"){
            tempobj2 = report;
          } else {
            this.reportTableData.push(report);
          }
          if(report['sno'] == '2.9'){
            this.reportTableData.push(tempobj1);
            this.reportTableData.push(tempobj2);
          }
        }
      })
    })
  }

  getIndicatorsHeirarchy(){
    this.activeSpinner = true;
    let postdata = {};
    this.indicatorTableData = [];
    postdata['ay'] = this.ay;
    this.submitdataservice.FetchIndicators(postdata).subscribe(data =>{
            
      if(data.length > 0)
         this.type == "admin-weightage" ? this.preparedataforweights(data) : this.preparedataforhtml(data); 
      else 
          this.indicatorTableData = [];
      this.activeSpinner = false;
    });
  }
  getStateIndicator(){
    this.activeSpinner = true;
    let postdata = {};
    this.indicatorTableData = [];
    postdata['ay'] = this.ay;
    this.submitdataservice.getIndicatorsHeirarchys(postdata).subscribe(data =>{
      
      if(data.length > 0)
         this.type == "admin-approval" ? this.preparedataforhtml(data) : this.preparedataforweights(data); 
      else 
          this.indicatorTableData = [];
      this.activeSpinner = false;
    });

  }
  getDistrictIndicator(){
    this.activeSpinner = true;
    let postdata = {};
    this.indicatorTableData = [];
    postdata['ay'] = this.ay;
    this.submitdataservice.getIndicatorsHeirarchyy(postdata).subscribe(data =>{
      
      if(data.length > 0)
         this.type == "admin-approval" ? this.preparedataforhtml(data) : this.preparedataforweights(data); 
      else 
          this.indicatorTableData = [];
      this.activeSpinner = false;
    });

  }

  preparedataforhtml(data){
    let index = 0;
    data.forEach(element => {
      let i = 0;
      element['childList'].forEach(list => {
        if(list['year'] == this.ay){
          this.indicatorsdata.forEach(obj => {
            if(obj['uuid'] == list['entityUUID']){
              list['rank'] = obj['rank'];
              list['score'] = obj['score'];
              list['manualV'] = obj['manualV'];
              list['actualval'] = this.getDecimalFixed(obj['actualV']);
              i++
            index++;
            list['index'] = index;
            if(i == 1){
              this.indicatorTableData.push(element);
            }
            this.indicatorTableData.push(list);
            }
          });
      }
      });
    });
  }

  
  preparedataforweights(data){
    let index = 0;
    data.forEach(element => {
      let i = 0;
      element['childList'].forEach(list => {
        if(list['year'] == this.ay){
          Object.keys(this.indicatorsdata).forEach(indid => {
            
            if(indid == list['entityUUID']){
              // list['rank'] = obj['rank'];
              // list['score'] = obj['score'];
              // list['actualval'] = obj['actualV'];
              let inddata = this.indicatorsdata[indid]
              list['value'] = inddata['updatedVal'] ?  inddata['updatedVal'] : inddata['val']
              i++
            index++;
            list['index'] = index;
            if(i == 1){
              this.indicatorTableData.push(element);
            }
            this.indicatorTableData.push(list);
            }
          });
      }
      });
    });
  }
  checkvalue(val){
    if(val)
     return val;
    return '-';
  }

  getDecimalFixed(num){
    if(isNaN(num))
      return num;
    else
      return Number(num).toFixed(2);
    }
  checkscorevalue(val){
    return val == 0 ? 0 : (val !=0 && val ? (val).toFixed(2) : '')
  }
  submit(){
    let postdata = {
      "action": "MODIFY",
      "ay": this.ay,
      "cType": this.constants.LOCATION_CONSTANT['STATE'],
      "component": 2,
      "data": JSON.stringify(this.formatmanualdata()),
      "lu": this.stateuuid,
      "userId": this.userdetails['loggedUserData']['userProfile']['userId'],
      "userType": this.userdetails['roles'][0],
      "view": this.constants.VIEWS['admin']
      }
      this.submitdataservice.modifyData(postdata).subscribe(data =>{
        if(data.status){
          this.toastr.success("Data modified successfully")
          this.activeModal.close('load')
        } else if(data.statuscode == 420){
          this.logsrv.logoutuserandsessionclear();
        } else {
          this.toastr.error("Error while updating data")
        }
      })
  }
  submitModifyData(){
    let postdata = {
      "action" : "MODIFY",
      "ay": this.ay,
      "subTp" : this.subtimeperiod,
      "cType": this.constants.LOCATION_CONSTANT['DISTRICT'],
      "component": 2,
      "data": JSON.stringify(this.formatmodifyData()),
      "lu" : this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID'],
      "userId": this.userdetails['loggedUserData']['userProfile']['userId'],
      "userType": this.userdetails['roles'][0],
      "view": this.constants.VIEWS['admin']
    }
    this.submitdataservice.modifyData(postdata).subscribe(data =>{
      if(data.status){
        this.toastr.success("Data modified successfully")
        this.activeModal.close('load')
      } else if(data.statuscode == 420){
        this.logsrv.logoutuserandsessionclear();
      } else {
        this.toastr.error("Error while updating data")
      }
    })
}
indicatorValueChange(row){
  row['valuechanged'] = true;
}

  formatmanualdata(){
    let array = [];
    this.indicatorTableData.forEach(list =>{
      if(list['type'] != 'theme'){
        if(list['manualV']){
          let obj = {
            "id" : list.entityUUID,
            "value" : (list['manualV']).toString()
          }
          array.push(obj);
        }
      }
    });
     let finalobj = {}
     finalobj[this.ay] = array;
     return finalobj;
  }
  formatmodifyData(){
    let array = [];
    this.editreportTableData.forEach(list =>{
      if(list['valuechanged']){
        let obj = {
          "id" :list.uuid,
          "value" :(list['manualV']).toString()
        }
        array.push(obj);
      }
    });
    let finaldata = {};
    finaldata[this.ay] = array;
    return finaldata;
  }
}
